<template>
    <div class="flex flex-col h-full">
        <SmartBreadcrumbs
            type="InertiaLink"
            class="flex-none"
            :pages="[
                {
                    name: $tc('messages.battles', 1),
                    href: meta.links.index,
                },
            ]"
        />
        <BattlePlay :battle="battle" :meta="meta" class="flex-1" />
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import BattlePlay from '@/components/pageSpecific/BattlePlay.vue';

export default {
    components: {
        BattlePlay,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'battle'],
};
</script>
